"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicColumnSlideout = void 0;
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const JuvareTheme_1 = require("@juvare/common-web-ui/JuvareTheme");
const ModalSlideout_1 = require("@juvare/common-web-ui/ModalSlideout");
const PartialError_1 = require("@juvare/common-web-ui/PartialError");
const SnackbarHelper_1 = require("@juvare/common-web-ui/SnackbarHelper");
const dynamic_columns_1 = require("../../../../../../ui/features/dynamic-columns");
const hooks_1 = require("../../../../../../ui/hooks");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const DynamicColumnSlideoutContent_1 = require("./DynamicColumnSlideoutContent");
const DynamicColumnSlideout = (props) => {
    const dynamicColumnRequest = {
        filterData: {},
        offset: (props.rowsPerPage ?? 0) * (props.page ?? 0),
        limit: props.rowsPerPage ?? 0,
    };
    const dynamicColumnClient = (0, hooks_1.useDynamicColumnClient)();
    const { data } = (0, dynamic_columns_1.useDynamicColumnsList)(dynamicColumnRequest);
    const dynamicColumn = data?.rows.find((row) => row.id === props.id);
    return (react_1.default.createElement(ModalSlideout_1.ModalSlideout, { open: !!props.id, onClose: props.onClearActiveRow, "data-test": 'dynamic-column-slideout' }, dynamicColumn ? (react_1.default.createElement(material_1.Box, { sx: {
            overflow: 'auto',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: JuvareTheme_1.themeColors.surface.primary,
        } },
        react_1.default.createElement(ModalSlideout_1.ModalSlideoutTopBar, { isOpaque: true },
            react_1.default.createElement(ModalSlideout_1.ModalSlideoutTopBarDefaultActions, { onClose: props.onClearActiveRow, menuItems: [
                    {
                        label: 'Delete',
                        onClick: () => {
                            if (!dynamicColumn) {
                                return;
                            }
                            const handleDelete = () => {
                                (0, DialogHelper_1.showConfirmDialog)({
                                    title: 'Delete custom field?',
                                    content: (react_1.default.createElement(material_1.Typography, null, `By deleting this field, it will be permanently removed from all lists and filters.`)),
                                    confirmLabel: 'Delete Field',
                                    onConfirm: () => dynamicColumnClient
                                        .deleteColumn({ id: dynamicColumn.id })
                                        .then(() => {
                                        (0, SnackbarHelper_1.showAlertSnackbar)({
                                            message: 'Field deleted',
                                            type: 'success',
                                        });
                                        props.onReload();
                                        props.onClearActiveRow();
                                    })
                                        .catch(DialogHelper_1.handleErrorDialog),
                                });
                            };
                            if (props.onBeforeDelete && dynamicColumn) {
                                props
                                    .onBeforeDelete(dynamicColumn)
                                    .then((canDelete) => canDelete && handleDelete())
                                    .catch(() => undefined);
                            }
                            else {
                                handleDelete();
                            }
                        },
                    },
                ] })),
        react_1.default.createElement(material_1.Box, { sx: { display: 'flex', flexDirection: 'column', flex: 1, gap: 0 } },
            react_1.default.createElement(ModalSlideout_1.ModalSlideoutHeader, { sx: { pb: 1 } },
                react_1.default.createElement(ModalSlideout_1.ModalSlideoutTitleArea, { title: dynamicColumn.name, titleTypographyVariant: 'h5' })),
            react_1.default.createElement(DynamicColumnSlideoutContent_1.DynamicColumnSlideoutContent, { dynamicColumn: dynamicColumn, onReload: props.onReload, onClearActiveRow: props.onClearActiveRow })))) : (react_1.default.createElement(PartialError_1.PartialError, { error: new Error('Custom Field not found.') }))));
};
exports.DynamicColumnSlideout = DynamicColumnSlideout;
